export default __webpack_public_path__ + "static/media/nz.9aa89d3e.svg";